import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../services/supabase.ts';
import { formatCurrency, formatDate } from '../../utils/formatters.ts';

interface TenantPaymentsProps {
  tenantId: string;
}

const TenantPayments: React.FC<TenantPaymentsProps> = ({ tenantId }) => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchPayments = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('payments')
        .select('*')
        .eq('tenant_id', tenantId)
        .order('payment_date', { ascending: false });

      if (error) throw error;
      setPayments(data || []);
    } catch (error) {
      console.error('Error fetching payments:', error);
    }
    setLoading(false);
  }, [tenantId]);

  useEffect(() => {
    fetchPayments();
  }, [fetchPayments]);

  const handlePaymentClick = (paymentId: string) => {
    navigate(`/payments/${paymentId}`);
  };

  if (loading) return <div>Loading payments...</div>;

  return (
    <div className="tenant-payments">
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Amount</th>
            <th>Mode</th>
            <th>Collected By</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {payments.map(payment => (
            <tr 
              key={payment.id}
              onClick={() => handlePaymentClick(payment.id)}
              style={{ cursor: 'pointer' }}
              className="payment-row"
            >
              <td>{formatDate(payment.payment_date)}</td>
              <td>{formatCurrency(payment.total_amount)}</td>
              <td>{payment.payment_mode}</td>
              <td>{payment.payment_to}</td>
              <td>{payment.notes || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {payments.length === 0 && <p className="no-data">No payments found</p>}
    </div>
  );
};

export default TenantPayments;
